Livewire.on('notificationShown', function () {
    setTimeout(function () {
        Livewire.dispatch('hide-notification');
    }, 5000);

    setTimeout(function () {
        Livewire.dispatch('reset-notification-data');
    }, 5500);// 10 seconds
});